module.exports = __webpack_public_path__ + "img/Snorres-kongesoger_Olav-som-helgen.0433e787.jpg";